import { api } from "../config/axios"

export const loginUser = async ({ username, password }) => {
  const response = await api.post("/auth/login", { username, password })
  return response.data
}

export const refreshTokens = async () => {
  const response = await api.post("/auth/token/refresh")
  return response.data
}

export const logoutUser = async () => {
  const response = await api.post("/auth/logout")
  return response.data
}

export const fetchAuthMe = async () => {
  const response = await api.get("/auth/me")
  return response.data
}
